import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { TOPIC } from '../../../commons/api';
import localStorage from '../../../utils/localStorage';
import StyledTable from "../../../commons/styles/table";
import { DrawerFooter } from '../../../commons/styles/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Drawer, Form, Input, Button, Select, Tooltip, Popconfirm, message } from 'antd';

const { Option } = Select;

const TopicMaster = ({ match, translationCache }) => {
  const [datasource, setDatasource] = useState([]);
  const [formObject, setFormObject] = useState({});
  const [visible, setVisible] = useState(false);
  const [Type, setType] = useState([]);
  const [Redisbd, setRedisbd] = useState([]);
  const hRef = useRef(null);
  const siteId = match?.params?.siteId || localStorage.get('currentSite');

  useEffect(() => {
    getMasterList();
    _Redisbd();
    _TypeOnSelect();
  }, [siteId]);

  const getMasterList = () => {
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${TOPIC.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(Object)
      .then((response) => {
        setDatasource(response.data);
      })
      .catch(() => { });
  };

  const _curdOperation = (datas) => {
    const accessToken = localStorage.get('accessToken');
    const payload = {
      method: 'POST',
      url: `${TOPIC.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: datas
    };
    axios(payload)
      .then((response) => {
        if (response && response.data) {
          getMasterList();
          hRef.current.resetFields();
          message.success(response.data.message);
          setVisible(false);
        }
      })
      .catch(() => { });
  };

  const _delete = (record) => {
    const accessToken = localStorage.get('accessToken');
    let orgDeleteHeaders = {
      method: 'DELETE',
      url: `${TOPIC.DELETE}?SiteId=${siteId}&Id=${record.Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('Role Deleted');
          getMasterList();
          hRef.current.resetFields();
          setVisible(false);
        } else {
          message.error('Error in delete');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _TypeOnSelect = () => {
    const accessToken = localStorage.get('accessToken');
    const type = {
      method: 'GET',
      url: `${TOPIC.GetTopicTypes}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        setType(response.data);
      })
      .catch(() => { });
  };

  const _Redisbd = () => {
    const accessToken = localStorage.get('accessToken');
    const type = {
      method: 'GET',
      url: `${TOPIC.GetRedisDB}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        setRedisbd(response.data);
      })
      .catch(() => { });
  };

  const onSubmit = (operation) => {
    let values = hRef.current.getFieldsValue('Site_Form');
    let saveObject = {
      ...values
    };
    if (operation === 'create') {
      _curdOperation(saveObject);
    } else if (operation === 'update') {
      _updateSiteAPI(saveObject);
    }
  };

  const _updateSiteAPI = (updateObject) => {
    const accessToken = localStorage.get('accessToken');
    let orgUpdateHeaders = {
      method: 'PATCH',
      url: `${TOPIC.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(orgUpdateHeaders)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
          setVisible(false);
          setFormObject({});
          getMasterList();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    if (hRef.current) {
      hRef.current.setFieldsValue(record);
    }
    setFormObject(record);
    setVisible(true);
  };

  const onClose = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setVisible(false);
    setFormObject({});
  };

  const addNew = () => {
    if (hRef.current) {
      hRef.current.resetFields();
    }
    setVisible(true);
    setFormObject({});
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const columns = [
    {
      title: translation('Topic'),
      dataIndex: 'Topic',
      key: 'Topic'
    },
    {
      title: translation('Type'),
      dataIndex: 'Type',
      key: 'Type'
    },
    {
      title: translation('RedisDB'),
      dataIndex: 'RedisDB',
      key: 'RedisDB'
    },
    {
      title: translation('Action'),
      dataIndex: 'Action',
      key: 'Action',
      render: (text, record) => (
        <>
          <Button className="ant-btn" onClick={() => _editRecord(record)} >
            <EditOutlined />
          </Button>
          <Popconfirm
            title={translation('Are you sure delete ?')}
            onConfirm={(e) => {
              e.stopPropagation();
              _delete(record);
            }}
            okText={translation('yes')}
            cancelText={translation('no')}
          >
            <Tooltip title={translation('Delete')}>
              <Button type="primary" className="ant-btn">
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={addNew}
        style={{ background: '#214972', marginBottom: '10px' }}
      >
        <PlusOutlined /> Add
      </Button>
      <StyledTable size="small" columns={columns} dataSource={datasource} pagination={false} />
      <Drawer
        title={formObject && formObject.Id ? translation('Update Topic') : translation('Create Topic')}
        width={720}
        closable
        onClose={onClose}
        open={visible}
      >
        <Form
          layout="vertical"
          ref={hRef}
          name="Site_form"
          initialValues={formObject}
          onFinish={onSubmit}
        >
          <Form.Item
            label={translation('Topic')}
            name="Topic"
            rules={[{ required: true, message: 'Please select topic !' }]}
          >
            <Input
              placeholder={translation('Please enter Topic')}
              disabled={formObject.Topic ? true : false}
            />
          </Form.Item>
          <Form.Item
            label={translation('Type')}
            name="Type"
            rules={[{ required: true, message: 'Please select type !' }]}
          >
            <Select placeholder={translation('Please select type')}>
              {Type.map((value, index) => (
                <Option key={index} value={value.Type}>
                  {value.Type}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation('RedisDB')}
            name="RedisDB"
            rules={[{ required: true, message: 'Please enter redisDB' }]}
          >
            <Select placeholder={translation('Please select RedisDB')}>
              {Redisbd.map((value, index) => (
                <Option key={index} value={value.RedisDB}>
                  {value.RedisDB}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        <DrawerFooter>
          {!formObject.Id ? (
            <Button
              style={{ marginRight: 8 }}
              onClick={() => onSubmit('create')}
              type="primary"
            >
              {translation('Create')}
            </Button>
          ) : (
            <Button
              style={{ marginRight: 8 }}
              onClick={() => onSubmit('update')}
              type="primary"
            >
              {translation('Update')}
            </Button>
          )}
          <Button type='primary' onClick={onClose}>{translation('Cancel')}</Button>
        </DrawerFooter>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(TopicMaster);